import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const DigitalSettings = (props) => {
  const { serviceProductForm } = props

  const {
    entityState: {
      options: { digital },
    },
    handlers,
  } = serviceProductForm

  const { custom_domain, templatable, type } = digital

  return (
    <DashboardModule title="Digital Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Type">
            <select
              data-value-type="text"
              name="options.digital.type"
              value={type}
              {...handlers}
            >
              <option value="">Please select ...</option>
              <option value="microsite">Microsite</option>
              <option value="interactive_image">Interactive Image</option>
              <option value="social_image">Social Image</option>
              <option value="other">Other</option>
            </select>
          </Form.Field>

          {type === 'microsite' && (
            <Form.Field label="Custom Domain" marginTop={['large', 0]}>
              <select
                data-value-type="boolean"
                name="options.digital.custom_domain"
                value={custom_domain}
                {...handlers}
              >
                <option value="false">No</option>
                <option value="true">Yes</option>
              </select>
            </Form.Field>
          )}

          {type === 'social_image' && (
            <Form.Field label="Templatable" marginTop={['large', 0]}>
              <select
                data-value-type="boolean"
                name="options.digital.templatable"
                value={templatable}
                {...handlers}
              >
                <option value="false">No</option>
                <option value="true">Yes</option>
              </select>
            </Form.Field>
          )}
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

DigitalSettings.propTypes = {
  serviceProductForm: PropTypes.object,
}

export default DigitalSettings
